import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Instantly scroll to the top of the page
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto", // Ensures no smooth scrolling, just instant jump
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
